import { REQUEST_STATUSES } from "@/constants/index.js";

export const initialState = {
  searchOptions: [],
  status: REQUEST_STATUSES.IDLE,
  err: null,
};
